<ng-container [formGroup]="paramGroup">
    <h3
        class="form-header"
        mat-dialog-title
        i18n="@@c27f1609332ee8b368f8061a22ff9e9aa3f6fc8b"
        t="c27f1609332ee8b368f8061a22ff9e9aa3f6fc8b"
        >Characteristic</h3
    >

    <div class="grid">
        <div fxLayout="row" fxLayoutGap="10px">
            <tsl-form-field fxFlex="100%">
                <tsl-label for="category"
                    >{{ role }}
                    <span
                        i18n="@@0fbc0bbce830bd50141fac696299f15bed5563c8"
                        t="0fbc0bbce830bd50141fac696299f15bed5563c8"
                        >Category</span
                    >
                </tsl-label>
                <tsl-select
                    id="category"
                    required
                    fullWidth
                    formControlName="toolCategory"
                    (selectionChange)="onChangeCategory($event)"
                >
                    <tsl-option *ngFor="let cat of filterCategories" [value]="cat.id">
                        {{ translate.get(cat.category) }}</tsl-option
                    >
                </tsl-select>
                <tsl-error *ngIf="toolCategory.invalid" i18n="@@Required" t="Required">Required</tsl-error>
            </tsl-form-field>
        </div>
        <!-- Subcategory -->
        <div fxLayout="row" fxLayoutGap="10px">
            <tsl-form-field fxFlex="100%">
                <tsl-label for="subcategory"
                    >{{ translate.get(role) }}
                    <span
                        i18n="@@301aa836dcab43dc07491c377b37e32132225c19"
                        t="301aa836dcab43dc07491c377b37e32132225c19"
                        >Sub-Category</span
                    ></tsl-label
                >
                <tsl-select
                    id="subcategory"
                    required
                    fullWidth
                    formControlName="toolSubcategory"
                    (selectionChange)="onChangeSubcategory($event)"
                >
                    <tsl-option *ngFor="let sub of filterSubcategories" [value]="sub.id"
                        >{{ translate.get(sub.subcategory) }}
                    </tsl-option>
                </tsl-select>
                <tsl-error *ngIf="toolSubcategory.invalid" i18n="@@Required" t="Required">Required</tsl-error>
            </tsl-form-field>
        </div>
        <div fxLayout="row" fxLayoutGap="10px">
            <tsl-form-field fxFlex="100%">
                <tsl-label
                    for="parameter"
                    i18n="@@c27f1609332ee8b368f8061a22ff9e9aa3f6fc8b"
                    t="c27f1609332ee8b368f8061a22ff9e9aa3f6fc8b"
                    >Characteristic</tsl-label
                >
                <input id="parameter" tslInput required fullWidth maxlength="100" formControlName="parameterType" />
                <tsl-error *ngIf="parameterType.invalid" i18n="@@Required" t="Required">Required</tsl-error>
            </tsl-form-field>
        </div>
        <div fxLayout="row" fxLayoutGap="10px">
            <tsl-form-field fxFlex="100%">
                <tsl-label for="parameterValue" i18n="@@Value" t="Value">Value</tsl-label>
                <input id="parameterValue" tslInput fullWidth maxlength="50" formControlName="paramValue" />
            </tsl-form-field>
        </div>
    </div>

    <div class="right">
        <button tsl-button outline color="black" size="small" (click)="onClose()" i18n="@@Cancel" t="Cancel"
            >Cancel</button
        >
        <button tsl-button filled color="blue" size="small" [disabled]="paramGroup.invalid" (click)="onSave()" i18n
            >Add</button
        >
    </div>
</ng-container>
